import React, { JSX } from "react";
import Footer from "../footer/footer";
import { Countdown } from "../../../types";
import Subheader from "../subheader/subheader";
import PageLayout from "../page-layout";
import ScrollableContent from "../scrollable-content";

export type Props = {
  roomCode?: string;
  onBack?: () => void;

  footerLabel?: string;
  footerJsx?: JSX.Element;
  footer?: JSX.Element;

  header?: JSX.Element;
  headerLabel?: string;

  subHeaderJsx?: JSX.Element;
  subHeaders?: string[];

  hack?: JSX.Element[];
  countdown?: Countdown;
  countdownThreshold?: number;

  extraTopLabel?: string;
  error?: string;

  hideConnected?: boolean;
  children?: React.ReactNode;
};

const Page: React.FunctionComponent<Props> = (props) => {
  return (
    <PageLayout hack={props.hack}>
      {props.header}
      <Subheader subheaders={props.subHeaders} />
      {props.subHeaderJsx ? (
        <div
          className={
            "text-sm sm:text-base bg-gray-med pl-2 self-stretch border-b-4 border-black"
          }
        >
          ▸ {props.subHeaderJsx}
        </div>
      ) : (
        ""
      )}
      <ScrollableContent basis="basis-10" className="relative">
        {props.children}
      </ScrollableContent>
      {props.footer ? (
        props.footer
      ) : (
        <Footer
          onBack={props.onBack}
          text={props.footerLabel}
          jsx={props.footerJsx}
        />
      )}
    </PageLayout>
  );
};

export default Page;
